import React, { useState, useEffect } from 'react';
import './SideMenu.css';
import axios from '../../hooks/fetchWithAuth';
import { Button, Avatar} from "@mui/material";
import { FaList } from "react-icons/fa";
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import EditableTextField2 from '../EditableTextField2';
import Comments from '../Comments';
import { Span, Div, Flex } from "../../style";
import config from '../../config';
import getCookie from '../../hooks/getCookie';
import { getAvatarUrl } from '../../utils/getAvatarUrl';



export default function SideMenu({ fetchLogs, selectedCard, logs, comments, setComments, fetchTiBoardData,}) {
  const backendIp = config.backend_ip;
  const nameComplete = getCookie("nome_completo");
  const username = getCookie("username");
  const storedUserId = getCookie("userId");
  const sessionId = getCookie("session_id");

  const [newComment, setNewComment] = useState('');
  const [isLogsVisible, setIsLogsVisible] = useState(false);

  useEffect(() => {
    if (selectedCard) {
      listComments(selectedCard.id).then(updateComments);
      fetchLogs(selectedCard.id);
    }
  }, [selectedCard]);

  const toggleLogsVisibility = () => {
    setIsLogsVisible(prevState => !prevState);
  };

  const scrollToBottom = () => {
    const secondColumn = document.querySelector('.second-column');
    if (secondColumn) {
      secondColumn.scrollTop = secondColumn.scrollHeight;
    }
  };

  const updateComments = (comments) => {
    setComments(comments);
  };

  const setUpCard = async (newComment) => {
    try {
      await axios.put(`${backendIp}/api/board/ti/add_comment`, {
        card_id: selectedCard.id,
        comment_text: newComment,
        name_complete: nameComplete,
        user: username,
        session_id: sessionId
      });
      const updatedComments = await listComments(selectedCard.id);
      updateComments(updatedComments);
      setNewComment('');
      fetchLogs(selectedCard.id);
    } catch (error) {
      return null;
    }
  };

  const listComments = async (cardId) => {
    try {
      const response = await axios.put(`${backendIp}/api/board/ti/list_comments`, {
        card_id: cardId,
        session_id: sessionId,
        user: username
      });
      return response.data;
    } catch (error) {
      return [];
    }
  };

  // Função para converter string de data para objeto Date para comparação
  const parseDateTime = (dateTimeString, type) => {
    try {
      if (type === 'comment') {
        // Formato: "11:07 08/08/2025"
        const [time, date] = dateTimeString.split(' ');
        const [hours, minutes] = time.split(':');
        const [day, month, year] = date.split('/');
        return new Date(year, month - 1, day, hours, minutes);
      } else {
        // Formato: "07/08/2025 - 15:29"
        const [date, time] = dateTimeString.split(' - ');
        const [day, month, year] = date.split('/');
        const [hours, minutes] = time.split(':');
        return new Date(year, month - 1, day, hours, minutes);
      }
    } catch (error) {
      return new Date();
    }
  };

  // Função para misturar e ordenar logs e comentários
  const getMixedActivity = () => {
    const activities = [];

    // Adicionar comentários
    comments.forEach(comment => {
      activities.push({
        type: 'comment',
        data: comment,
        datetime: parseDateTime(comment.comment_created_at, 'comment'),
        originalDateTime: comment.comment_created_at
      });
    });

    // Adicionar logs se visíveis
    if (isLogsVisible) {
      logs.forEach(log => {
        activities.push({
          type: 'log',
          data: log,
          datetime: parseDateTime(log.datetime, 'log'),
          originalDateTime: log.datetime
        });
      });
    }

    // Ordenar por data (mais recente primeiro)
    return activities.sort((a, b) => b.datetime - a.datetime);
  };

  return (
    <div style={{ display: 'flex' }}>
      <div>
        <Flex style={{ marginBottom: '20px', marginLeft: '5px', display: 'flex', justifyContent: 'space-between', height: '0px', paddingBottom: '15px' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <FaList style={{ fontSize: '20px', marginRight: '15px' }} />
            <Span style={{}}>Atividade</Span>
          </div>
          <Flex style={{ alignItems: 'center', justifyContent: 'center' }}>
            <Button style={{ textTransform: 'none' }} className='button-show-details' onClick={toggleLogsVisibility}>
              {isLogsVisible ? "Ocultar Detalhes" : "Mostrar Detalhes"}
            </Button>
            <KeyboardDoubleArrowDownIcon
              id="scrollToBottomIcon"
              onClick={scrollToBottom}
              style={{ cursor: 'pointer' }}
            />
          </Flex>
        </Flex>
        <Flex style={{ marginBottom: '20px' }}>
          <EditableTextField2
            selectedCard={selectedCard}
            fetchTiBoardData={fetchTiBoardData}
            listComments={listComments}
            comments={comments}
            setComments={updateComments}
            text={newComment}
            onSave={setUpCard}
            placeholder="Adicione um novo comentário..."
            multiline
            rows={2}
          />
        </Flex>
        <div className='container-comments'>
          {getMixedActivity().map((activity, index) => (
            <div key={`${activity.type}-${index}`}>
              {activity.type === 'comment' ? (
                <Comments comments1={[activity.data]} fetchTiBoardData={fetchTiBoardData} selectedCard={selectedCard} />
              ) : (
                <Div className='comment log-item'>
                  <Flex>
                    <div>
                      <Flex>
                        <Avatar className='comment-avatar' src={getAvatarUrl(activity.data.username)} />
                        <Flex style={{ flexDirection: 'column', maxWidth: '25vw', overflowWrap: 'break-word' }}>
                          <Span className='comment-timestamp'>{activity.originalDateTime}</Span>
                          <Span className='user-comments' style={{ color: '#666' }}>{activity.data.log}</Span>
                        </Flex>
                      </Flex>
                    </div>
                  </Flex>
                </Div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
